import React, {useEffect, useState} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import axios from "axios";
import CoinsCart from "./CoinsCart";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {useMediaQuery} from "beautiful-react-hooks";
import TopGainers from "./TopGainers";
import TopBanner from "./TopBanner";
import {Calculator} from "./Calculator";
import PaginatedItems from "./PaginatedItems";
import { Link } from "react-router-dom";
import PageItemsAcc from "./PageItemsAcc";
import BasicTabs from "./BasicTabs"
import LoadingAcc from "./LoadingAcc";
import LoadingTable from "./LoadingTable";
import { GroupCard } from "./GroupCard";
import Footer from "./Footer";
import ReactRecaptcha3 from 'react-google-recaptcha3';
import { toast } from "react-toastify";
import BannerSlider from "./BannerSlider";
import SlideDesktop from "./SlideDesktop";
import SliderTypes from "./SliderTypes";
import LandHeader from "./LandHeader";
import AppHeader from "./AppHeader";
const BASEURL = 'https://api.sinatether.com/Auth/login/'


export default function Home(){
    const navigate = useNavigate();
    const [symbol,setSymbol] = useState([])
    const isSmall = useMediaQuery('(max-width: 768px)')
    const [search,setSearch] = useState()
    const [resultSym,setResultSym] = useState([])
    const [TeterPriceBuy,setTeterPriceBuy] = useState()
    const [TeterPriceSell,setTeterPriceSell] = useState()
    const [isAll,setIsAll] = useState(false)
    const [isLoading,setIsLoading] = useState(true)
    const [loadButton ,setLoadButton] = useState(false)
    const [result,setResult] = useState([])
    const [tabChange,setTabChange] = useState(false)
    const [key,setKey] = useState(0)
    const [notFound,setNotFound] = useState(false)
    const [Phone,setPhone] = useState("")
    const [error,seterror] = useState('')
    const [loadingp,setLoadingp] = useState(false)







    let query = useQuery()
    let source = ''
    let ref = ''
    try{
     source = query.get("utm_source")
     ref =  query.get("ref")
    if (source){

        localStorage.setItem("source",source)


    }
    if (ref){
     localStorage.setItem("ref",ref)

    }
    }catch{
    }





     
    function useQuery() {
        const { search } = useLocation();

        return React.useMemo(() => new URLSearchParams(search), [search]);
        }


    function hanldleSearch(event) {
        setSearch(event.target.value)

    }



    function changeToall(){
        setLoadButton(true)
        setIsAll(true)
    }








    


    function GoToLogin(){
        navigate('/login')
    }


    useEffect(() => {
        async function fetchData() {
          // You can await here
          const response = await axios.get('https://api.sinatether.com/Auth/GetTeter').then((res)=>{

            if (res.status==200){
                 setTeterPriceBuy(res.data['teterprice']['buy'])
                 setTeterPriceSell(res.data['teterprice']['sell'])

            }

       })
          // ...
        }
        fetchData();
      }, []);


    
  

    async function requestHakdleGetCoin() {
               await  axios.get('https://api.sinatether.com/Auth/CoinGet/').then((res)=>{



           if (res.status == 200)
           {
                          



                            setSymbol(res.data['pull'])
                            setResult(res.data['pull'])
                            if (flag == 0){
                                const ress = res.data['pull'].sort(function (a, b) {
                                    return b.changeRate - a.changeRate
                                }) 
                                setResult(ress)
                               setTabChange(true)
                               let k = Math.random()
                                setKey(k)
                                flag = flag + 1
                                console.log(flag)

                            }
                          
                            setIsLoading(false)


           }








         })


    }





   

        var flag = 0
    

        useEffect(()=>{


                 const resultInterval = () => {
                         requestHakdleGetCoin()
                         setTimeout(resultInterval, 100000);



                     };
                 flag = 0
                 resultInterval();
                 setSearch('')




             },[])







    useEffect(()=>{
   const results = symbol.filter(({symbol,persionName}) => {
          return(
              persionName.includes(search))
            ||
              symbol.includes(search.toUpperCase())
      });

      if (search){
        if(results.length === 0){
            setNotFound(true)
        }else {
            setNotFound(false)
 
        }
    }

      setResultSym(results)
    },[search])



    function handleTabs(value) {
        let k = Math.random()

        console.log(value)

        let lidata = symbol

        console.log(lidata)


        if (value === 1) {
            const res = lidata.sort(function (a, b) {
                return b.changeRate - a.changeRate
            }) 
            setResult(res)
           setTabChange(true)
                       setKey(k)


           }
        else if (value === 2) {
            console.log("kcjisdin")
            const res = lidata.filter(sym => sym.type === 'leve')
            setResult(res)
            setTabChange(false)
                    setKey(k)



        }
           else if (value === 3) {
            const res = lidata.sort(function (a, b) {
                return a.changeRate - b.changeRate
            })
            setResult(res)
           setTabChange(true)
                       setKey(k)


           }


        else if (value === 4) {
                const res = lidata.sort(function (a, b) {
                    return a.buy - b.buy
                })
            console.log(res)
                setResult(res)
            setKey(k)
            setTabChange(true)


        }
         else if (value === 0) {
             console.log(symbol)
             
            setResult(symbol)
            setTabChange(false)
            setKey(k)



            } else if (value === 5) {
                const res = lidata.sort(function (a, b) {
                    return b.buy - a.buy
                })
                setResult(res)
                setTabChange(false)
                        setKey(k)


            } 



    }



    useEffect(()=>{




    },[tabChange])



    
const fetchToken = async (Phone,token,source)=>{
    return axios.post(BASEURL,{'phone':Phone,"token":token,'source':source},
        {withCredentials:true})
}





function HandelClick(event) {
    event.preventDefault()






    if (!Phone || Phone.length < 11 ){
        toast.error("لطفا شماره تلفن خود را به درستی وارد نمایید")
        return
    }

    setLoadingp(true)







        fetchToken(Phone,'',source).then(
            (res) => {
                console.log(res)
                if (res.data['status'] == 200) {

                            navigate('/verify', {state:{phone:Phone},replace:true})
 
 
                }else {
                    toast.warning(res.data['message'])
                    setLoadingp(false)
 
                }
            }
 
 
        )

    
       

   }



   function handelCheck(event){
    var pattern = new RegExp(/^09[0-9]{9}/);
    var pattern1 =  new RegExp(/^@#@_[0-9]{2}/)
    let p = event.target.value
    if (pattern1.test(p)){
        if (p.length == 6){
            seterror('')
            setPhone(p)
            return
        }
    }








   /*if(p.length==11)
   {*/
       if (!pattern.test(p))
        {
        seterror('لطفا شماره تلفن خود را درست وارد نمایید')
        }else if(p.length==11) {
           seterror('')
           setPhone(p)
       }
       else {
                       seterror('لطفا شماره تلفن خود را درست وارد نمایید')
       }
  /* }
   else {
       seterror('شماره تلفن وارد شده صحیح نیست!')
   }*/


}





useEffect(()=>{

var referrer = document.referrer;
console.log("آدرس صفحه ای که کاربر از آن به سایت  آمده است: " + referrer);


},[])














    return(
        <>




            {/* <div id={"preloader"}>
                <div className={"sk-three-bounce"}>
                    <div className={"sk-child sk-bounce1"}>

                    </div>
                    <div className={"sk-child sk-bounce2"}>

                    </div>
                    <div className="sk-child sk-bounce3">

                    </div>
                </div>
            </div> */}

  {/*  <div className="modal " id="myModal" aria-hidden="true"
                 aria-labelledby="exampleModalToggleLabel" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">

                        <div className="modal-body pt-0 pl-0 pr-0 ">
                                                    <div className={'row pb-0 pt-0 '}>


                            <div className="col-6">
                            </div>


                            <div className="col-6 text-left pr-4">



                        <span type="button" className=" text-medium closesp" data-bs-dismiss="modal"
                                    aria-label="Close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20.88" height="15.88" viewBox="0 0 122.88 122.88">
  <path id="close-button" d="M61.44,0A61.44,61.44,0,1,1,0,61.44,61.44,61.44,0,0,1,61.44,0ZM74.58,36.8c1.74-1.77,2.83-3.18,5-1l7,7.13c2.29,2.26,2.17,3.58,0,5.69L73.33,61.83,86.08,74.58c1.77,1.74,3.18,2.83,1,5l-7.13,7c-2.26,2.29-3.58,2.17-5.68,0L61.44,73.72,48.63,86.53c-2.1,2.15-3.42,2.27-5.68,0l-7.13-7c-2.2-2.15-.79-3.24,1-5l12.73-12.7L36.35,48.64c-2.15-2.11-2.27-3.43,0-5.69l7-7.13c2.15-2.2,3.24-.79,5,1L61.44,49.94Z" fill="#2dbd96" fill-rule="evenodd"/>
</svg>


                        </span>

                            </div>
                        </div>

                            <img src={'Artboard.jpg'} alt={'tabligh'}/>
                        </div>

                    </div>
                </div>
        </div>

        */}
       

            <div id="main-wrapper" className={"show"}>
                
               <LandHeader/>

                


                    <div className="sinabackv8ss">

                        <div className="contentbb555">

                            <div className="fjsflex53535">

                                <div className={`texttitit3425 ${isSmall ? '' : 'w-50' } `}>
                                    <h3 className="ftext-h122">
                                        با سینا تتر

                                    </h3>
                                    <div className="stext-h122">
                                        پازل سرمایه گذاری‌‌تو کامل کن

                                    </div>

                                    <div className="ttext-h122">

                                        خرید و فروش ارزهای دیجیتال در سینا تتر

                                    </div>


                                    <div className="subdshfhphonej424">
                                        <input type="tel" className="myinputsptia443" placeholder="شماره موبایل خود را وارد نمایید"  onChange={handelCheck}  required/>
                                        <div>
                                            <button className="jdhsbuttoncust44" disabled={loadingp ? true : false} onClick={HandelClick}>

                                                {loadingp ?
                                                                    <img className="jsdhshgd" src={'../img-camp/loading.svg'}/>
 

                                                :

                                                <>شروع کنید</>

                                                }




                                            </button>
                                        </div>
                                    </div>

                                </div>

                                <div className="fjsuhfstye424">
                                    
                                    <img src="https://static.sinatether.com/images/pazel-sina.gif" alt="سینا تتر"/>

                                </div>

                            </div>

                        </div>
                        

                    </div>



                    






                <div className="price-grid section-padding pt-0 pb-0 sptipadding">

                    {isSmall ?
                    <>


                    
                    
                    </>
                    :



                    <SlideDesktop/>


                        


                        
                        

                        
                        
                      
                    
                   
                    }




                    <div className="fjsflex53535 djnsudgtrfddd dliscard4242">

                    <TopGainers/>



                    </div>



                    {isSmall ?

<div>

    <BannerSlider/>



   


 

</div>

:

<></>

                    }



                   



<SliderTypes/>


                    <div className={'divcn w-100    plr0'}>

                        

                  <div className={'DesktopMainPage mb-5'}>





                      {isSmall ?

                          <Tabs>
                              <TabList >
                              </TabList>

                              <TabPanel>


                                  

                                   <div className="accordion mt-4 ">
                                       {isSmall?

                                                <div className="text-center fdkshjfhgge24235">

                                                <h5 className="tex-medf242">
                                                    قیمت ارزهای دیجیتال
                              

                                                </h5>



                                                </div>
                                                :

                                                <></>
                                                }

                                       <div className="row w-100 rsearch sdkjerywgrwrw2342">
                                       <input className={'input-search text-large'} placeholder={' جستجو ارز دیجیتال'} onChange={hanldleSearch}/>

                                       </div>

                                       <div className={' pad-b12'}>
                                                        
                                                        {symbol ?

                                                            <BasicTabs handleTabs={handleTabs}/>
                                                            :
                                                            <></>
                                                        }

                                                    </div>



                                                    {isLoading ?
                                                        <>

                                                        <LoadingAcc/>

                                                            <LoadingAcc/>
                                                        <LoadingAcc/>
                                                            <LoadingAcc/>
                                                        <LoadingAcc/>
                                                        <LoadingAcc/>


                                                        </>

                                                        :


                                                        <>



                                       <div class="row py-2 margi-css354 "><div class="col-4 pl-4 text-large text-normal">نام</div><div class="col-4 text-center pl-0 text-large text-normal">
                                           
                                          قیمت جهانی
                                         (تتر)

                                           
                                           </div><div class="col-4  text-large text-normal">تغییرات24h</div></div>




                                        {
                                            resultSym.length>0 && search != '' ?

                                               resultSym.map((sym) =>

                                               

                                                <div className="accordion-item">
                                                    <h2 className="accordion-header border-top py-1" id={`heading${sym['symbol']}`}>
                                                        <button className="accordion-button pl-1 pr-0 pt-0 pb-0 collapsed" type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapse${sym['symbol']}`}
                                                                aria-expanded="true"
                                                                aria-controls={`collapse${sym['symbol']}`}>

                                                            <Link className="col-4 pointer linkStyle"
                                                               to={`/${sym['symbol'].split('-')[0]}`}>
                                                                <div className="text-black">
                                                                    <img className="imgcoin "
                                                                         src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                                                                    <span
                                                                        className="spanHeaderAcc">  <span
                                                                        className="ft-external-link text-large text-normal dis-grid">{sym['persionName']}


                                                        <span
                                                                            className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>
                                                        </span>
                                                                        
                                                                        
                                                                        
                                                                        </span>
                                               
                                                                </div>
                                                            </Link>


                                                            <div
                                                                className="col-4 pointer text-right text-blue-primery text-large priceTt"
                                                            >{new Intl.NumberFormat("fa",{maximumFractionDigits:8}).format(sym['sell'])}
                                                                
                                                                </div>
                                                                    <div
                                                                className="col-3 pointer text-right text-blue-primery text-large priceTt"
                                                            >

                                                            <span
                                                                className={'text-medium priceTt'}>
                                                                {sym['changeRate']>=0 ?
                                                                    <>


                                                                          <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                                          <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                                                          <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                                                                          <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                                                                        </svg>


                                                                <span className={'text-success pl-1'}>
                                                                    {sym['changeRate']}%

                                                                </span>
                                                                          </>

                                                                    :

                                                                    <>






                                                            <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                              <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                                              <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                              <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                            </svg>



                                                                <span className={'text-danger pl-1'}>
                                                                    {-1 * Number(sym['changeRate'])}%

                                                                </span>


                                                                    </>
                                                                }
                                                            </span>


                                                            </div>


                                                        </button>
                                                    </h2>
                                                    <div id={`collapse${sym['symbol']}`}
                                                         className="accordion-collapse collapse "
                                                         aria-labelledby={`heading${sym['symbol']}`}
                                                         data-bs-parent="#accordionExample">
                                                        <div className="accordion-body ">


                                                            <ul className={'ul-custom'}>
                                                                <li className={'col-6 pl-0 pr-0 '}>
                                                                    <h6 data-inline-formset={true}
                                                                        className={'col-12 text-success text-large text-normal '}>
                                                                            
                                                                            <div className="text-normal phyrfjshbf">خرید:</div> 
                                                                        {new Intl.NumberFormat("fa").format(sym['BuyIrt'])}
                                                                        <span className={' tomn242553'}>تومان</span>
                                                                    </h6>
                                           


                                                                </li>

                                                                <li className={'col-6 pr-0 pl-0'}>
                                                                    <h6 data-inline-formset={true} className={'col-12 text-large text-danger text-normal content-left '}>
                                                                        <div className="text-normal phyrfjshbf">
                                                                            فروش:
                                                                        </div>

                                                                        {new Intl.NumberFormat("fa").format(sym['sellIrt'])}
                                                                        <span className={' tomn242553'}>تومان</span>

                                                                    </h6>
                                                                  

                                                                </li>

                                                            </ul>


                                                            <div className="rowButton pt-3 pb-2 px-2 ">

                                                            

                                                                <div className="col-6 px-1 px---1">
                                                                <Link to="/login">


                                                                    <button
                                                                        className="btn btn-outline-success py---5 buy text-large w-100 pointer mb-0 btnsm text-success"
                                                                        onClick={GoToLogin}>خرید
                                                                    </button>
                                                                    </Link>
                                                                </div>

                                                                <div className="col-6 px-1 px---1">
                                                                <Link to="/login">

                                                                    <button
                                                                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                                                                        >فروش
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                                :
                                                <>



                                                
                                   <div className="accordion-item">
                                                    <h2 className="accordion-header border-top py-1" id={`headingUSDT`}>
                                                        <button className="accordion-button  pl-1 pr-0 pt-0 pb-0 " type="button"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#collapseUSDT`}
                                                                aria-expanded="true"
                                                                aria-controls={`collapseUSDT`}>

                                                            <Link className="col-6 pointer linkStyle text-white"
                                                               to={`/USDT`}>
                                                                <div className="text-black">
                                                                    <img className="imgcoin "
                                                                         src={`https://sinatether.com/CoinsImg/USDT.png`} alt={""}/>
                                                                    <span
                                                                        className="spanHeaderAcc">  <span
                                                                        className="ft-external-link text-large text-normal dis-grid">تـتر
                                                                        
                                                                        <span
                                                                        className="text-medium text-muted">USDT</span>
                                                                        </span>
                                                                        
                                                                        </span>
                                                
                                                                </div>
                                                            </Link>


                                                            <div
                                                                className="col-5 pointer text-right text-blue-primery text-large priceTt"
                                                            > <span
                                                                className={'text-medium priceTt'}></span></div>


                                                        </button>
                                                    </h2>
                                                    <div id={`collapseUSDT`}
                                                         className="accordion-collapse collapse show "
                                                         aria-labelledby={`headingUSDT`}
                                                         data-bs-parent="#accordionExample">
                                                        <div className="accordion-body ">


                                                            <ul className={'ul-custom'}>
                                                                <li className={'col-6 pl-0 pr-0'}>
                                                                    <h6 data-inline-formset={true}
                                                                        className={'col-12 text-success text-large text-normal'}>
                                                                            <div className="text-normal phyrfjshbf">
                                                                            خرید:
                                                                    

                                                                            </div>
                                                                            
                                                                        
                                                                        {new Intl.NumberFormat("fa").format(TeterPriceBuy)}
                                                                        <span className={' tomn242553'}>تومان</span>
                                                                    </h6>
                                                                


                                                                </li>

                                                                <li className={'col-6 pl-0 pr-0"'}>
                                                                    <h6 data-inline-formset={true} className={'col-12 text-large text-danger text-normal content-left '}>

                                                                        <div className="text-normal phyrfjshbf">
                                                                            فروش:

                                                                        </div>



                                                                        {new Intl.NumberFormat("fa").format( TeterPriceSell)}
                                                                        <span className={' tomn242553'}>تومان</span>

                                                                    </h6>

                                                                </li>

                                                            </ul>


                                                            <div className="rowButton pt-1 pb-1 px-2 ">

                                                                
                                                                

                                                             

                                                                <div className="col-6 px-1 px---1">
                                                                <Link to={"/login"}>

                                                                    <button
                                                                        className="btn btn-outline-success py---5 buy text-large w-100 pointer mb-0 btnsm text-success"
                                                                        >خرید
                                                                    </button>
                                                                    </Link>
                                                                </div>

                                                                <div className="col-6 px-1 px---1">
                                                                <Link to={"/login"}>

                                                                    <button
                                                                        className="btn btn-outline-danger py---5 buy text-large w-100 pointer mb-0 btnsm text-danger"
                                                                        >فروش
                                                                    </button>
                                                                    </Link>
                                                                </div>
                                                            </div>


                                                        </div>
                                                    </div>
                                                </div>
                                                




                                                {result ?
                                                    <PageItemsAcc key={key} itemsPerPage={25} items={result}/>
                                                    :
                                                    <PageItemsAcc key={key} itemsPerPage={25} items={symbol}/>


                                                }
                                                </>
                                        }
                                        </>
                                            }
                                   </div>
                                 



                              </TabPanel>


                          </Tabs>
                          :

                          <>


                          <Tabs>
                              <TabList>
                              </TabList>


                              <TabPanel>
                                  <table className="table table68 row table-cusj3424 table68 row plr-32">
                                      


                                     


                                          <>

                                          <div className="text-center fdkshjfhgge24235"><h5 className="tex-medf242">قیمت ارزهای دیجیتال</h5></div>

                                         
                          <div className="row    w-100 pl-0 pr-0 ">

<div className="col-6 pl-0 pr-0 ">

<div className={'pr-0 pl-0'}>
                                <BasicTabs handleTabs={handleTabs}/>

                            </div>

</div>
<div className="col-6 text-left pt-1">
<div className={'search13242 '}>
<input className={'input-search text-large pr-4'} placeholder={'  جستجو ارز دیجیتال'} onChange={hanldleSearch}/>
</div>

</div>





</div>

                                         

                                              <div className={'row  mborder w-100 pl-1 pb-2 pt24'}>
                                                  <div className={'col-2 pt-2 '}>
                                                      <span className={'text-normal text-dark'}>نام</span>


                                                  </div>


                                                  <div className={'col-2  pt-2 pb-0'}>
                                                      <span className={'text-normal text-dark'}>خرید</span>


                                                  </div>


                                                  <div className={'col-2  pt-2 pb-0'}>
                                     <span className={'text-normal text-dark'}>
                                               فروش

                                     </span>


                                                  </div>


                                                  <div className={'col-2 pt-2 pb-0'}>
                                                      <span className={'text-normal text-dark'}>قیمت جهانی</span>


                                                  </div>

                                                  
                                                  <div className={'col-2 pt-2 pb-0'}>
                                                      <span className={'text-normal text-dark'}> تغییرات 24h</span>


                                                  </div>


                                                  <div className={'col-2 pt-2 pb-0'}>
                                                      <span className={'text-normal text-muted'}></span>


                                                  </div>

                                              </div>


                                              <tbody>

                                              {isLoading ?
                                                                <>

                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>
                                                                <LoadingTable/>

                                                                </>


                                                :

                                                <>

                                             



                                            { resultSym.length>0 && search != '' ?

                                            resultSym.map((sym)=>(
                                                                            
                                                    <div className={'row tr_row  py-2 px-1 '}>
                                                    <div className={'col-2 '}>
                                                        <Link className="pointer linkStyle"
                                                        to={`/${sym['symbol'].split('-')[0]}`}>
                                                            <div className="text-black">
                                                                <img className="imgcoin "
                                                                    src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
                                                                <span
                                                                    className="spanHeaderAcc">
                                                    <span
                                                    className="ft-external-link tt0562 text-large">{sym['persionName']}


                                                   <span className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>

                                                    
                                                    
                                                    
                                                    
                                                    </span>

                                                    </span>

                                                            </div>
                                                        </Link>


                                                    </div>
                                                    {sym ?
                                                        <>

                                                            <div className={'col-2 '}>
                                                                <div className={' table-hover'}>
                                                                    <p className={'mb-0 m0562 text-success'}>{new Intl.NumberFormat("fa").format(sym['BuyIrt'])} </p>
                                                                </div>

                                                            </div>
                                                            <div className={'col-2 '}>
                                                                <div className={' table-hover'}>
                                                                    <p className={'mb-0 m0562 text-danger'}> {new Intl.NumberFormat("fa").format(sym['sellIrt'])} </p>
                                                                </div>
                                                            </div>
                                                            <div className={'col-2 '}>
                                                                <div className={'table-hover'}>
                                                                    <p className={'mb-0 m0562 priceTt'}> {new Intl.NumberFormat("fa").format(sym['sell'])}</p>
                                                                </div>
                                                            </div>


                                                            <div class="col-2 pointer text-right text-blue-primery text-large priceTt">
                                                                <p className={'text-medium priceTt mb-0 m0562 pt-1'}>
                                                                {sym['changeRate']>=0 ?
                                                                    <>


                                                                          <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                                          <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                                                          <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                                                                          <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                                                                        </svg>


                                                                <span className={'text-success pl-1'}>
                                                                    {sym['changeRate']}%

                                                                </span>
                                                                          </>

                                                                    :

                                                                    <>






                                                            <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                                              <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                                              <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                              <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                            </svg>



                                                                <span className={'text-danger pl-1'}>
                                                                    {-1 * Number(sym['changeRate'])}%

                                                                </span>


                                                                    </>
                                                                }
                                                            </p>



        </div>

                                                        </>
                                                        :
                                                        <>



                                                        </>


                                                    }


                                                    <div className={'col-2 text-left  '}>

                                                        <div
                                                            className=" float-left text-right  px-2 ">

                                                            <div className="col-3 px-1 px---1 btn-size btnnSi">
                                                                <Link to={`/${sym['symbol'].split('-')[0]}`}>

                                                                    <button
                                                                        className="btn btn-primary text-large w-100 py---6 buy mb-0 pointer ng-star-inserted btn-size ">
                                                                        <span className={'text-large text-white pr-1 pt-1 pb-1'}>خرید</span>
                                                                        <span className={'text-large text-white-50'}>|</span>
                                                                        <span className={'text-large text-white pl-1'}>
                                                                            فروش
                                                                        </span>
                                                                    </button>

                                                                </Link>

                                                            </div>



                                                        </div>


                                                    </div>

                                                    </div>

                                            ))
                                                  


                                                  :


                                                      <>


<div className={'row tr_row py-2 px-1 '}>
                                                              <div className={'col-2 '}>
                                                                  <Link className="pointer linkStyle"
                                                                     to={`/USDT`}>
                                                                      <div className="text-black">
                                                                          <img className="imgcoin "
                                                                               src={`https://sinatether.com/CoinsImg/USDT.png`} alt={""}/>
                                                                          <span
                                                                              className="spanHeaderAcc">
                                         <span
                                             className="ft-external-link tt0562 text-large">
                                                 تـتر

                                                 <span className="text-medium text-muted">USDT</span>

                                                 
                                                 </span>

                                    </span>

                                                                      </div>
                                                                  </Link>


                                                              </div>
                                                              {TeterPriceBuy ?
                                                                  <>

                                                                      <div className={'col-2 '}>
                                                                          <div className={' table-hover'}>
                                                                              <p className={'mb-0 m0562 text-success'}>{new Intl.NumberFormat("fa").format(TeterPriceBuy)} </p>
                                                                          </div>

                                                                      </div>
                                                                      <div className={'col-2 '}>
                                                                          <div className={' table-hover'}>
                                                                              <p className={'mb-0 m0562 text-danger'}> {new Intl.NumberFormat("fa").format(TeterPriceSell)} </p>
                                                                          </div>
                                                                      </div>
                                                                      <div className={'col-2 '}>
                                                                          <div className={' table-hover'}>
                                                                              <p className={'mb-0 m0562 priceTt'}></p>
                                                                          </div>
                                                                      </div>

                                                                      <div className={'col-2 '}>
                                                                          <div className={' table-hover'}>
                                                                              <p className={'mb-0 m0562 priceTt'}></p>
                                                                          </div>
                                                                      </div>


                                                                  </>
                                                                  :
                                                                  <>


                                                                      <td>
                                                                          <div className={' table-hover'}>
                                                                              <p className={'mb-0 m0562 text-success'}>
                                                                                  
                                                                              </p>
                                                                          </div>

                                                                      </td>
                                                                      <td>
                                                                          <div className={' table-hover'}>
                                                                              <p className={' text-danger'}>
                                                                                  
                                                                              </p>
                                                                          </div>
                                                                      </td>
                                                                      <td>
                                                                          <div className={' table-hover'}>
                                                                              <p className={'mb-0 m0562 priceTt'}> 
                                                                              </p>
                                                                          </div>
                                                                      </td>

                                                                  </>


                                                              }


                                                              <div className={'col-2 text-left  '}>

                                                                  <div
                                                                      className=" float-left text-right  px-2 ">

                                                                      <div className="col-3 px-1 px---1 btn-size btnnSi">
                                                                          <Link to={'/USDT'}>

                                                                              <button
                                                                                  className="btn mybtn-ku text-large w-100 py---6 buy mb-0 pointer ng-star-inserted btn-size ">
                                                                                  <span className={'text-large text-kuco pr-1 pt-1 pb-1'}>خرید</span>
                                                                                  <span className={'text-large text-kuco'}>|</span>
                                                                                  <span className={'text-large text-kuco pl-1'}>
                                                                                      فروش
                                                                                  </span>
                                                                              </button>

                                                                          </Link>

                                                                      </div>



                                                                  </div>


                                                              </div>

                                                          </div>


<>


                                                <PaginatedItems key={key}  itemsPerPage={20}
                                                                items={result}/>



                                                </>
                                                      </>
                                                  
                                              }

                                              </>



                      }





                                              

                                              </tbody>

                                          </>

                                      
                                  </table>
                              </TabPanel>
                              
                          </Tabs>
                          </>
                      }






                      </div>


                </div>




                </div>














                <div className="getstart section-padding">

                    {isSmall?
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-8">
                              
                            </div>
                        </div>
                        <div className="d-row-content">


                            <div className={'row'}>

                                <div className={'img-4524 col-12 '}>

                                <div className="back3232">


                                    <img src={'https://static.sinatether.com/images/lock.gif'} className={'css-content onecase2022'} alt="اموزش ثبت نام در سینا تتر"/>

                                    </div>


                                </div>

                                <div className={'content-4524 col-12'}>

                                    <div className="text-white tilte9897823724">

                                      


                                        ثبت نام</div>
                                    <p className="p-4524 text-white content980834753">
                                        ثبت نام توی سینا تتر به راحت ترین شکل ممکن صورت میگیره،کافیه شماره تماس خودتون رو وارد کنید و با استفاده از کد یکبار مصرف عضوی از خانواده  بزرگ سینا تتر شوید.

                                    </p>



                                </div>

                            </div>






                            <div className={'row'}>


                            <div className={'img-4524 col-12'}>

                                <div className="back3333">


                                        <img src={'images/finger.gif'} className={'css-content twocase2020'} alt="احراز هویت در سینا تتر"/>

                                        </div>


                                        </div>



                                    <div className={'content-4524 col-12'}>
                                        

                                        <div className="text-white tilte9897823724">

                                            


                                             احرازهویت</div>
                                        <p className="p-4524 text-white content980834753">


                                        با استفاده از منوی سمت راست وارد صفحه احراز هویت شوید و بعد از  تکمیل فرم و ارسال اطلاعات لازم ، منتظر تایید اطلاعاتتون توسط پشتیبان سینا تتر باشید.


                                        </p>



                                    </div>


                                    

                                </div>








<div className={'row'}>

<div className={'img-4524  col-12'}>
        <div className="back3232">


    <img src={'https://static.sinatether.com/images/wallet.gif'} className={'css-content threecase'} alt="خرید و فروش ارز های دیجیتال در سینا تتر"/>

    </div>


</div>

<div className={'content-4524 col-12'}>

    <div className="text-white tilte9897823724">

        


         ثبت درخواست خرید ارزدیجیتال</div>
    <p className="p-4524 text-white content980834753">
    از لیست 500 تایی کوین های سینا تتر ، ارز مورد نظرتون رو انتخاب کنید و به مقداری که تمایل دارید ، خرید کنید.
    <br/>
    </p>



</div>

</div>

                        </div>


                    </div>

                    :

                                <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-xl-8">
                                        <div className="section-title">
                                            <div className={"text-white title909090"}>نحوه خرید ارز دیجیتال</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-row-content">


                                    <div className={'css-row-child'}>

                                        <div className={'img-4524 col-6 '}>
                                        <div className="back3232">


                                        <img src={'https://static.sinatether.com/images/lock.gif'} className={'css-content dfjjcontent3431'} alt="اموزش ثبت نام در سینا تتر"/>

                                            </div>
                                        </div>

                                        <div className={'content-4524 col-6'}>

                                            <div className={'text-white mini-content90909'}>

                                            


                                                ثبت نام</div>
                                            <p className="p-4524 text-white contetn-909090">
                                                ثبت نام توی سینا تتر به راحت ترین شکل ممکن صورت میگیره،کافیه شماره تماس خودتون رو وارد کنید و با استفاده از کد یکبار مصرف عضوی از خانواده  بزرگ سینا تتر شوید.

                                            </p>



                                        </div>

                                    </div>






                                    <div className={'css-row-child'}>



                                            <div className={'content-4524 col-6'}>

                                                <div className={"text-white mini-content90909"}>

                                                    


                                                    احرازهویت</div>
                                                <p className="p-4524 text-white contetn-909090">


                                                با استفاده از منوی سمت راست وارد صفحه احراز هویت شوید و بعد از  تکمیل فرم و ارسال اطلاعات لازم ، منتظر تایید اطلاعاتتون توسط پشتیبان سینا تتر باشید.


                                                </p>



                                            </div>


                                            <div className={'img-4524 col-6  '}>
                                            <div className="back3333">


                                            <img src={'https://static.sinatether.com/images/finger.gif'} className={'css-content dfjjcontent3432'} alt="احراز هویت در سینا تتر"/>
                                                </div>

                                            </div>

                                        </div>








            <div className={'css-row-child'}>

            <div className={'img-4524  col-6'}>

                <div className="back3232">

            <img src={'https://static.sinatether.com/images/wallet.gif'} className={'css-content dfjjcontent3434'} alt="خرید و فروش ارز های دیجیتال در سینا تتر"/>

            </div>


            </div>

            <div className={'content-4524 col-6'}>

            <div className={"text-white mini-content90909"}>

                


                ثبت درخواست خرید ارزدیجیتال</div>
            <p className="p-4524 text-white contetn-909090">
            از لیست 500 تایی کوین های سینا تتر ، ارز مورد نظرتون رو انتخاب کنید و به مقداری که تمایل دارید ، خرید کنید.
            </p>



            </div>

            </div>

                                </div>


                            </div>

                }


                </div>










                {isSmall ?


                    <div className="get-touch mypadding">
                    <div className="container padding-0">
                    <div className="row justify-content-center">
                            <div className="col-xl-6">
                                <div className="section-title">
                                    <h1 className={'text-dark text-dark text-center myheav'}>چرا سیناتــتر ؟</h1>
                                </div>
                            </div>
                        </div>

                     <div className="heigetrhentkje4535">



                     <div className="heigetrhentkje4535">



<div className=" text-center uggetyyeyeee">
        <div className="get-touch-content">
            <div className="media">
                <div className="media-body fjsflex53535">

                    

                    <div className="icon6060t">
                        <img className="img-40402342" src="https://static.sinatether.com/images/auth.svg" alt="احراز هویت در  سینا تتر"/>
                    </div>

                    <div className="content606t0">

                    <div className="mmtitle">احراز هویت سریع  </div>
                    <p className="text-dark mb-0 cont3435"> در کمتر از 5 دقیقه
                    </p>

                    </div>
                </div>
            </div>
        </div>
    </div>



    <div className=" text-center uggetyyeyeee">
        <div className="get-touch-content">
            <div className="media">
                <div className="media-body fjsflex53535">

                    

                    <div className="icon6060t">
                        <img className="img-40402342" src="https://static.sinatether.com/images/support.svg" alt="پشتیبانی سینا تتر"/>
                    </div>

                    <div className="content606t0">

                    <div className="mmtitle">پشتیبانی 24ساعته  </div>
                    <p className="text-dark mb-0 cont3435 "> 24 ساعته 7 روز هفته
                    </p>

                    </div>
                </div>
            </div>
        </div>
    </div>



    <div className=" text-center uggetyyeyeee">
        <div className="get-touch-content">
            <div className="media">
                <div className="media-body fjsflex53535">

                    

                    <div className="icon6060t">
                        <img className="img-40402342" src="https://static.sinatether.com/images/karmozd.svg" alt="معامله تتر با کارمزد صفر"/>
                    </div>

                    <div className="content606t0">

                    <div className="mmtitle">  معامله تتر بدون کارمزد  </div>
                    <p className="text-dark mb-0 cont3435">    کارمزد ارزهای دیگر 0.2 % 
                    </p>

                    </div>
                </div>
            </div>
        </div>
    </div>



    <div className=" text-center uggetyyeyeee">
        <div className="get-touch-content">
            <div className="media">
                <div className="media-body fjsflex53535">

                    

                    <div className="icon6060t">
                        <img className="img-40402342" src="https://static.sinatether.com/images/coins.svg" alt="ارزهای سینا تتر"/>
                    </div>

                    <div className="content606t0">

                    <div className="mmtitle">تنوع بالای ارز دیجیتال </div>
                    <p className="text-dark mb-0 cont3435"> 

                    بیش از 500 رمز ارز
                    </p>

                    </div>
                </div>
            </div>
        </div>
    </div>








    </div>
                      

                        <div className="right-vecto545">
                       



                        </div>





                        <div className="left-vecto545">



</div>










                     </div>



                        </div>

                        </div>
                :



                <div className="get-touch mypadding">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-6">
                                <div className="section-title">
                                    <h1 className={'text-dark text-dark text-center myheav'}>چرا سیناتــتر ؟</h1>
                                </div>
                            </div>
                        </div>

                        <div className="">

                            <div className="row">

                                <div className="col-6 vector1">

                                    </div>


                                    <div className="col-6 vector2">

                                        </div>

                            </div>


                            
                        <div className="row widnjsjbfs">

                                


<div className="col-6  jufheuhbbbbbb ">
<div className=" text-center uggetyyeyeee ">
    <div className="get-touch-content">
        <div className="media">
            <div className="media-body fjsflex53535">

                

                <div className="icon6060t">
                    <img className="iconitt" src="https://static.sinatether.com/images/auth.svg" alt="پشتیبانی سینا تتر"/>
                </div>

                <div className="content606t0">
                <div className="mmtitle">احراز هویت سریع  </div>
<p className="text-dark mb-0 cont3435"> در کمتر از 5 دقیقه
</p>

                </div>
            </div>
        </div>
    </div>
</div>

<div className=" text-center">
    <div className="get-touch-content">
        <div className="media">
            <div className="media-body fjsflex53535">

                

                <div className="icon6060t">
                    <img className="iconitt" src="https://static.sinatether.com/images/support.svg" alt="پشتیبانی سینا تتر"/>
                </div>

                <div className="content606t0">

                <div className="mmtitle">پشتیبانی 24ساعته  </div>
<p className="text-dark mb-0 cont3435 "> 24 ساعته 7 روز هفته
</p>

                </div>
            </div>
        </div>
    </div>
</div>



    

</div>
<div className="col-6   ">
<div className=" text-center uggetyyeyeee">
    <div className="get-touch-content">
        <div className="media">
            <div className="media-body fjsflex53535">

                

                <div className="icon6060t">
                    <img className="iconitt" src="https://static.sinatether.com/images/karmozd.svg" alt="خرید تتر بدون کارمزد"/>
                </div>

                <div className="content606t0">

                <div className="mmtitle">  معامله تتر بدون کارمزد  </div>
<p className="text-dark mb-0 cont3435">    کارمزد ارزهای دیگر 0.2 % 
</p>

                </div>
            </div>
        </div>
    </div>
</div>

<div className=" text-center">
    <div className="get-touch-content">
        <div className="media">
            <div className="media-body fjsflex53535">

                

                <div className="icon6060t">
                    <img className="iconitt" src="https://static.sinatether.com/images/coins.svg" alt="ارزهای دیجیتال دسته بندی شده"/>
                </div>

                <div className="content606t0">

                <div className="mmtitle">تنوع بالای ارز دیجیتال </div>
<p className="text-dark mb-0 cont3435"> 

بیش از 500 رمز ارز
</p>

                </div>
            </div>
        </div>
    </div>
</div>

</div>


</div>

                  





                        </div>



                        <div className="just-center  ">

                            <div className="lastttx">
                            با سینا تتر پازل سرمایه گذاری تو کامل کن !

                                </div>

                                <div className="mdfhsyfsf353">

                                    <Link to={'/login'}>
                                        
                                    <button className="btn btnsjhrsrbr34">
                                        همین الان ثبت نام کن !
                                    </button>

                                    </Link>

                                </div>
                            </div>
                    
                             </div>



                </div>

                }



              <Footer/>

                
            </div>

        </>);
            }
